import React, { PropsWithChildren } from 'react'
import { Switch as HeadlessSwitch } from '@headlessui/react'
import classNames from 'classnames'
import { ReactFCC } from '@/types/react'

export interface IconSwitchProps extends PropsWithChildren<object> {
  checked: boolean
  disabled?: boolean
  onChange: (enabled: boolean) => void
  knobClassName?: string
  switchClassName?: string
}

export const IconSwitch: ReactFCC<IconSwitchProps> = ({
  checked,
  disabled = false,
  onChange,
  children,
  knobClassName,
  switchClassName,
}) => {
  const containerClasses = checked ? 'flex-row ' : 'flex-row-reverse'
  const animateSwitchClasses = checked
    ? 'transition-transform duration-200 translate-x-4'
    : 'transition-transform duration-200 -translate-x-4'

  return (
    <HeadlessSwitch
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      className={classNames(
        'relative box-content flex h-6 w-[50px] grow-0 shrink-0 items-center rounded-full',
        containerClasses,
        switchClassName,
      )}
    >
      <span
        aria-hidden="true"
        className={classNames(
          'flex box-content grow-0 shrink-0 items-center justify-center w-10 h-10 overflow-visible rounded-full bg-white',
          knobClassName,
          animateSwitchClasses,
        )}
      >
        {children}
      </span>
    </HeadlessSwitch>
  )
}
